import React, { Component } from 'react';
import {connect} from 'react-redux'
import PropTypes from 'prop-types';

import {updateData} from '../../../routers/data'
import {fetchCalc} from '../../../routers/settings'
import InputText from '../../components/inputText'
import InputSelect from '../../components/inputSelect'
import {FielsFilter} from '../functions'

class formTowing extends Component {
  static contextTypes = {
    router: PropTypes.object
  }

  state = {
    calc: false,
  };

  loadCalc = (name) => {
    const filter = ['towing']
    if (filter.indexOf(name) >=0){
      this.setState({calc: true});
    }
  }

  componentDidUpdate() {
    if (this.state.calc){
      this.props.fetchCalc(this.props.data, this.props.settings)
      this.setState({calc: false});
    }
  }

  onChange = (name, value, title, id) =>{
    const langUrl = this.context.router.route.location.pathname.split('/')[1]
    const { languages } = this.props.settings
    const langPlace = languages[langUrl].dataresume

    const key = (this.props.name + this.props.index).toLowerCase()
    const values = this.props.data[key]

    //Detect errors and save in state the message
    const result = FielsFilter(langPlace, name, value, values)

    if (result.isError){
      this.props.updateData({errors: {...this.props.data.errors, [id]: result}})
    } else if (this.props.data.errors[id] !== undefined) {
      delete this.props.data.errors[id]
      this.props.updateData({errors: {...this.props.data.errors}})
    }

    //Save values in state
    this.props.updateData({[key]: {...values, [name]: value}})
    this.loadCalc(name)
  }

  render() {
    const langUrl = this.context.router.route.location.pathname.split('/')[1]
    const { languages } = this.props.settings
    const langPlace = languages[langUrl].dataresume
    const langNames = languages[langUrl].dataresume.names
    const { towings } = languages[langUrl]

    const errors = this.props.errors
    const {index, name} = this.props
    const key = (this.props.name + this.props.index).toLowerCase()
    const values = this.props.data[key]

    return (
      <div className='col-lg-6 col-md-6 col-sm-12 col-xs-12 form-towing'>
        <div className='form-header'>
          <p className='title'>{langPlace.vehicle}</p>
          <p className='subtitle'>{`${langPlace[name]} #${index}`}</p>
        </div>
        <div className='col-md-6 col-sm-12 no-padding'>
          <InputText name='brand' title={langNames.brand} value={values} errors={errors} section={key} onChange={this.onChange}/>
        </div>
        <div className='col-md-6 col-sm-12 no-padding'>
          <InputText name='model' title={langNames.model} value={values} errors={errors} section={key} onChange={this.onChange}/>
        </div>
        <div className='col-md-4 col-sm-12 no-padding'>
          <InputText name='licensePlate' title={langNames.licensePlate} value={values} errors={errors} section={key} onChange={this.onChange}/>
        </div>
        <div className='col-lg-8 col-md-12 col-sm-12 no-padding'>
          <InputSelect name='towing' title={langNames.towing} value={values} array={towings} errors={errors} section={key} onChange={this.onChange}/>
        </div>
        <div className='col-lg-12 col-md-12 col-sm-12 padding-bottom-140'/>
      </div>
    )
  }
}

export default connect(
  (state) => ({settings: state.settings, data: state.data, errors: state.data.errors}),
  {updateData, fetchCalc}
)(formTowing)



// WEBPACK FOOTER //
// ./src/shared/routes/routeData/components/formTowing.js